import { useEffect } from "react";
import { ROUTER_URL } from "../../../../../constants/routerUrl";
import { IFinanceResource } from "../../../../../models/dashboard/staffDashboard";
import { connect, useDispatch } from "react-redux";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { setApps } from "../../../../../store/slices/master/appSlice";
import { getApps } from "../../../../../action/masters/appActionCreator";
import { IApps } from "../../../../../models/master/apps";
import { baseURL } from "../../../../../constants/commonConstants";

const FinanceResourceViewAll = (props: IFinanceResource) => {
  const { getFinanceResources, financeResources } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getFinanceResources(pageBlockId.financeResources, undefined);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setApps([]));
    };
  }, []);
  return (
    <div>
      <>
        <div className="widgets">
          <div className="title">
            <h2>All Finance Resources</h2>
          </div>
          <div className="card-wrap">
            <div className="row">
              {financeResources
                ?.filter((finance: IApps) => finance.displayOrNot)
                .map((finance: IApps) => (
                  <div className="col-md-12 mb-3" key={finance.id}>
                    <div className="resourcecard icon-visibility">
                      <a href={finance.url} target="_blank" className="h-100">
                        <div className="img">
                          <img src={baseURL + finance.image} alt="" />
                        </div>
                        <div className="dtls">
                          <h3 className="para-hide-1">{finance.name}</h3>
                          <p className="para-hide-2">{finance.description}</p>
                        </div>
                        <span>
                          <img
                            src="/assets/images/icon/arrow-right.svg"
                            alt=""
                          />
                        </span>
                      </a>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

const mapDispatchToProps = {
  getFinanceResources: (pageBlockId?: number, noOfItems?: number) =>
    getApps(undefined, pageBlockId, undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    financeResources: state.app.appsForTerm,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FinanceResourceViewAll);
